import { useState } from 'react';

export const JsonUploader = ({ inputFileRef, setJson }) => {
  const onChangeInput = event => {
    if (event?.target?.files?.length) {
      try {
        const fileReader = new FileReader();
        fileReader.readAsText(event.target.files[0], 'UTF-8');
        fileReader.onload = e => {
          setJson(JSON.parse(e.target?.result as string));
        };
      } catch (e) {
        alert('error parsing file!');
      }
    }
  };

  return (
    <input
      ref={inputFileRef}
      style={{ display: 'none' }}
      type="file"
      accept="application/JSON"
      name="logoImage"
      onChange={onChangeInput}
      onClick={(e: any) => (e.target.value = null)}
    />
  );
};
